import {
  EmptyState,
  Section,
  TitleAndDescription,
} from '@ferreri/prever-component-lib';
import { ContactUsIllustration } from 'components/illustration/ContactUsIllustration';
import { useWhatsappApi } from 'utils/useWhatsappApi';

export const PetCremationBenefit = () => {
  const { handleSendWhatsappMessage } = useWhatsappApi({
    phone: '+551132882526',
    text: 'Olá, gostaria de informações sobre Proteção Pet.',
  });

  return (
    <Section>
      <TitleAndDescription
        title="Acionar Proteção Pet"
        description="Para utilizar este benefício, entre em contato com nossa Central de Atendimento pelo WhatsApp."
      />
      <EmptyState
        illustration={<ContactUsIllustration />}
        buttonLabelPrimary="Entrar em contato pelo Whatsapp"
        onClickButtonPrimary={handleSendWhatsappMessage}
      />
    </Section>
  );
};
